export const SubStatusTitle = {
  PENDING_COMMERCIAL_STRUCTURE_NOT_COVERED: 'PENDING_COMMERCIAL_STRUCTURE_NOT_COVERED',
  WORKFLOW_EXECUTION_ERROR: 'WORKFLOW_EXECUTION_ERROR',
  INTEGRATION_ERROR_WITH_GERA: 'INTEGRATION_ERROR_WITH_GERA',
  PENDING_DIGITAL_SIGNATURE: 'PENDING_DIGITAL_SIGNATURE',
}
